import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

declare const $;

@Directive({
	selector: '[appResizeTop]'
})
export class ResizeTopDirective {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Input() elementNumber;
	@Output() stopped = new EventEmitter<any>();

	startY = 0;
	y = 0;
	parentHeight = 0;
	parentTop = 0;
	backgroundLeft = 0;
	mouseDown = false;

	@HostListener('mousedown', ['$event'])
	onMousedown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.startY = event.screenY;
		this.y = 0;
		this.parentHeight = $(this.el.nativeElement).parent()[0].clientHeight;
		if (this.componentData.config.type === 50) {
			this.parentTop = this.componentData.config.items[this.elementNumber].top;
			this.backgroundLeft = this.componentData.config.items[this.elementNumber].left;
		} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
			this.parentTop = this.componentData.config.merge_array[this.elementNumber].parser.top_offset;
			this.backgroundLeft = this.componentData.config.merge_array[this.elementNumber].parser.left_offset;
		} else {
			this.parentTop = this.componentData.config.parser.top_offset;
			this.backgroundLeft = this.componentData.config.parser.left_offset;
		}
		this.mouseDown = true;
	}

	@HostListener('document:mousemove', ['$event'])
	onMousemove(event: MouseEvent) {
		if (this.mouseDown) {
			event.preventDefault();
			this.y = event.screenY - this.startY;

			const heightToChange = this.parentHeight - this.y;
			const topToChange = this.parentTop + this.y;

			if (this.componentData.config.type === 50) {
				this.componentData.config.items[this.elementNumber].height = heightToChange;
			} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
				this.componentData.config.merge_array[this.elementNumber].item_height = heightToChange;
			} else {
				this.componentData.config.item_height = heightToChange;
			}

			$(this.el.nativeElement)
				.parent()
				.css({
					height: heightToChange + 'px',
					top: topToChange + 'px',
					'background-position': '-' + this.backgroundLeft + 'px -' + topToChange + 'px'
				});
		}
	}

	@HostListener('document:mouseup')
	onMouseup() {
		if (this.mouseDown) {
			this.mouseDown = false;
			if (this.componentData.config.type === 50) {
				this.stopped.emit({
					height: this.parentHeight - this.y,
					top: this.parentTop + this.y
				});
			} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
				this.componentData.config.merge_array[this.elementNumber].item_height = this.parentHeight - this.y;
				this.componentData.config.merge_array[this.elementNumber].parser.top_offset = this.parentTop + this.y;
				this.stopped.emit(this.componentData);
			} else {
				this.componentData.config.item_height = this.parentHeight - this.y;
				this.componentData.config.parser.top_offset = this.parentTop + this.y;
				this.stopped.emit(this.componentData);
			}
		}
	}

	constructor(private el: ElementRef) {}
}
